export default {
    required: 'El campo {{field}} es obligatorio.',
    integer: 'El campo {{field}} tiene que ser un número entero.',
    numeric: 'El campo {{field}} tiene que ser un número.',
    decimal: 'El campo {{field}} tiene que ser un número decimal.',
    minValue: 'El campo {{field}} tiene que ser mayor que {{min}}.',
    maxValue: 'El campo {{field}} tiene que ser menor que {{max}}.',
    minEqualValue:
        'El campo {{field}} tiene que ser mayor o igual que {{min}}.',
    maxEqualValue:
        'El campo {{field}} tiene que ser menor o igual que {{max}}.',
    minLength: 'El campo {{field}} tiene que ser mayor que {{min}}.',
    maxLength: 'El campo {{field}} tiene que ser menor que {{max}}.',
    between: 'Deber estar entre {{min}} y {{max}}.',
    email: 'El campo {{field}} tiene un formato de email inválido.',
    sameAs: 'El campo {{field}} tiene que ser igual que {eq}.',
    requiredUppercase:
        'El campo {{field}} tiene que tener una letra mayúscula.',
    regex: 'El campo {{field}} no es valido.',
};
